import { render, staticRenderFns } from "./PlatformAdd.vue?vue&type=template&id=9cf674a2&"
import script from "./PlatformAdd.vue?vue&type=script&lang=js&"
export * from "./PlatformAdd.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdd.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports